import React from 'react';
import { Link } from 'react-router-dom';

import PropTypes from 'prop-types';

import styles from './FooterLinkFamily.module.scss';

const FooterLinkFamily = ({ label, links }) => {
  const linkList = links.map((link) => (
    <li key={link.label}>
      <Link to={link.path}>{link.label}</Link>
    </li>
  ));

  return (
    <div className="col-md-4">
      <div className={styles.title}>{label}</div>
      <ol className={styles.links}>{linkList}</ol>
    </div>
  );
};

FooterLinkFamily.propTypes = {
  label: PropTypes.string.isRequired,
  links: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      path: PropTypes.string.isRequired,
    })
  ).isRequired,
};

export default FooterLinkFamily;
